module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_chapel-c82343248c19905dc974bac97d9cec06.svg";